import { render } from "./MenuPage.vue?vue&type=template&id=0d069b5d&scoped=true"
import script from "./MenuPage.vue?vue&type=script&lang=js"
export * from "./MenuPage.vue?vue&type=script&lang=js"

import "./MenuPage.vue?vue&type=style&index=0&id=0d069b5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d069b5d"]])

export default __exports__